import { Team__Pistons } from "./teams/Pistons";
import { Team__Natalias } from "./teams/Natalias";
import { Team__Grizzlies } from "./teams/Grizzlies";
import { Team__PecanBros } from "./teams/PecanBros";
import { Team__Potros } from "./teams/Potros";
import { Team__Joeles } from "./teams/Joeles";
import { Team__Llamas } from "./teams/Llamas";
import { Team__Adrianes } from "./teams/Adrianes";
import { Team__FlintTropics } from "./teams/FlintTropics";
import { Team__UTPaquime } from "./teams/UTPaquime";
import { Team__DublanCity } from "./teams/DublanCity";
import { Team__IrrigacionAgricola } from "./teams/IrrigacionAgricola";

export const teamList_2026_B = [
  Team__Pistons,
  Team__Natalias,
  Team__Grizzlies,
  Team__PecanBros,
  Team__Potros,
  Team__Joeles,
  Team__Llamas,
  Team__Adrianes,
  Team__FlintTropics,
  Team__UTPaquime,
  Team__DublanCity,
  Team__IrrigacionAgricola,
];
